import { Helmet } from "react-helmet-async"
import { AirlinesList } from "../../../../Admin/World"

export default function AirportsListPage() {
	return (
		<>
			<Helmet>
				<title>Airports</title>
			</Helmet>
			<AirlinesList />
		</>
	)
}
